import {deletee, get, patch, post} from "./index";

export const getAddressbookList = (params) => {
  const request = {
    subUrl: `/address_books.json`,
    params,
  };
  return get(request);
};

export const createAddressbook = (data) => {
  const request = {
    subUrl: `/address_books.json`,
    data,
  };
  return post(request);
};
export const updateAddressbookAPI = (data) => {
  let formData = new FormData();
  formData.set("email", data.email);
  formData.set("first_name", data.first_name);
  formData.set("last_name", data.last_name);
  formData.set("phone", data.phone);
  formData.set("role", data.role);
  const request = {
    subUrl: `/address_books/${data.id}`,
    data: formData,
  };
  return patch(request);
};

export const deleteAddressbook = (params) => {
  console.log("parm", params);
  const request = {
    subUrl: `/address_books/${params.id}`,
  };
  return deletee(request);
};
export const deleteDoctoroFromGroup = (params) => {
  let formData = new FormData();
  formData.set("address_book_id", params.address_book_id);
  console.log("parm", params);
  const request = {
    subUrl: `/direct_groups/${params.id}/remove_address_book.json`,
    data: formData,
  };
  return deletee(request);
};
